

























import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import RoleListBase from "./RoleListBase";

@Component
export default class RoleList extends RoleListBase {
	created() {
		super.created();
	}

	private contentModalText(): string {
		return this.contentModal;
	}

	showAllertToDeleteClick(itemsSelected: any) {
		this.showAlertBeforeDeleteBase(itemsSelected);
	}

	loadFilters(value: any) { super.loadFilters(value); }
	createNewClick(elementId: any) { super.createNewClick(elementId); }
	detailClick(elementId: any) { super.detailClick(elementId); }
	deleteClick(elementId: any) { this.deleteClick(elementId) }
};
